import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { authService } from '../../services';

export const AUTH_QUERY_KEY = 'auth';

export function useCurrentUser(token) {
  return useQuery({
    queryKey: [AUTH_QUERY_KEY, 'current'],
    queryFn: () => authService.getCurrentUser(),
    enabled: !!token,
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}

export function useEmergentAuth(onSuccessCallback) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (sessionId) => {
      console.log('[useEmergentAuth] Mutation function called with sessionId:', sessionId);
      return authService.emergentAuthCallback(sessionId);
    },
    onSuccess: (data) => {
      console.log('[useEmergentAuth] onSuccess callback triggered!', data);
      
      // Invalidate queries
      if (data.token) {
        console.log('[useEmergentAuth] Invalidating queries...');
        queryClient.invalidateQueries([AUTH_QUERY_KEY]);
      }
      
      // Call the custom success callback if provided
      if (onSuccessCallback) {
        console.log('[useEmergentAuth] Calling custom success callback...');
        onSuccessCallback(data);
      }
    },
    onError: (error) => {
      console.error('[useEmergentAuth] onError callback triggered!', error);
    },
    onSettled: (data, error) => {
      console.log('[useEmergentAuth] onSettled callback triggered!', { data, error });
    },
  });
}

export function useBecomeCreator() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => authService.becomeCreator(),
    onSuccess: () => {
      queryClient.invalidateQueries([AUTH_QUERY_KEY, 'current']);
    },
  });
}
